import css from "./registration.module.css";

export const Privacy = () => {
  return (
    <div className={css.privacy}>
      Wenn du ein Kundenkonto erstellst, stimmst du unseren{" "}
      <a href="/d/content/club/teilnahmebedingungen" target="_blank">
        CLUB-Teilnahmebedingungen
      </a>{" "}
      zu. Informationen zum Umgang mit Deinen Daten kannst du unseren{" "}
      <a href="/b/datenschutz" target="_blank">
        Datenschutzhinweisen
      </a>{" "}
      entnehmen.
    </div>
  );
};
